const Bnbbsc = () => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 32 32' fill='none'>
			<g clipPath='url(#clip0_366_9719)'>
				<path
					d='M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z'
					fill='#F3BA2F'
				/>
				<path
					d='M16 0.5C24.5604 0.5 31.5 7.43959 31.5 16C31.5 24.5604 24.5604 31.5 16 31.5C7.43959 31.5 0.5 24.5604 0.5 16C0.5 7.43959 7.43959 0.5 16 0.5Z'
					stroke='white'
					strokeOpacity='0.2'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M15.9998 6.3999L10.1018 12.2982L12.2714 14.4678L15.9998 10.7393L19.7305 14.4697L21.9001 12.3003L15.9998 6.3999ZM6.40002 15.9995L8.56943 18.1689L10.7391 15.9994L8.56958 13.83L6.40002 15.9995ZM12.2714 17.5318L15.9998 21.2602L19.7304 17.5298L21.901 19.6982L21.9001 19.6995L15.9998 25.5995L10.1016 19.7014L10.0985 19.6983L12.2714 17.5318ZM21.2609 16.0005L23.4303 18.1699L25.6 16.0005L23.4303 13.8309L21.2609 16.0005ZM14.3729 15.424L15.9999 13.797L18.2014 15.9986H18.2005L18.2025 15.9996L18.2014 16.0009L15.9999 18.2024L13.8003 16.0028L13.7972 15.9996L13.8003 15.9966L14.1859 15.611L14.3727 15.424H14.3729Z'
					fill='white'
				/>
			</g>
			<defs>
				<clipPath id='clip0_366_9719'>
					<rect width='32' height='32' fill='white' />
				</clipPath>
			</defs>
		</svg>
	);
};

export default Bnbbsc;
